import { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Inputs, ModalContext, Modals } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import EventService from 'Services/events';
import { setUserInfoAction } from 'Store/modules/auth/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchSaveUserphone } from './hooks';

const PhoneModal = (): JSX.Element => {
  const [phone, setPhone] = useState<string>();
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { hideModal } = useContext(ModalContext);
  const { mutateAsync } = useFetchSaveUserphone();

  const handleSubmit = async (): Promise<void> => {
    if (phone) {
      EventService.formSubmitted({
        screenId: 'RequestPhone',
        values: phone,
      });
      await mutateAsync(phone);
      dispatch(setUserInfoAction({ user: { phone } }));
      hideModal();
    }
  };
  return (
    <Modals.Centered
      maxSize="S"
      onClose={hideModal}
      hasClose
      title={t('TaxScreen.RetrievalInfo.modal.title')}
      subtitle={t('TaxScreen.RetrievalInfo.modal.subtitle')}
      primaryButton={{
        label: t('TaxScreen.RetrievalInfo.modal.button'),
        onClick: handleSubmit,
      }}
      buttonsAlign="center"
    >
      <Inputs.Phone
        value={phone}
        label={t('RetrievalInfo.phoneInput.label')}
        placeholder="(1) 483 1212891"
        defaultCountry="MX"
        onChange={(value, error) => {
          setPhone(value);
          setHasError(error);
        }}
        id="phoneInput"
        hasError={hasError}
        errorMsg={t('RetrievalInfo.Input.error')}
      />
    </Modals.Centered>
  );
};

export default PhoneModal;
